module.exports = __webpack_public_path__ + "img/tree1_2021_small.6e6b3440.gif";